if (!customElements.get("loading-indicator")) {
  class LoadingIndicator extends HTMLElement {
    constructor() {
      super();
      this.resizeObserver = new ResizeObserver(this.updateHeight.bind(this));
    }

    connectedCallback() {
      this.innerHTML = `
        <div class="loading-indicator-inner">
          <i class="fas fa-spinner-third animate-spin"></i>
        </div>
      `;

      this.targetGrid = document.querySelector("#partbot-product-grid");
      if (this.targetGrid) {
        this.updateHeight();
        this.resizeObserver.observe(document.documentElement);
      }
    }

    disconnectedCallback() {
      this.resizeObserver.disconnect();
    }

    updateHeight() {
      if (!this.targetGrid) return;

      const gridRect = this.targetGrid.getBoundingClientRect();
      const parentRect = this.targetGrid.parentElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const remainingHeight = windowHeight - gridRect.top;
      const elementHeight = Math.min(
        gridRect.height || parentRect.height,
        parentRect.height,
      );

      const minHeight = Math.max(200, Math.min(remainingHeight, elementHeight));

      this.style.minHeight = `${minHeight}px`;
    }
  }

  customElements.define("loading-indicator", LoadingIndicator);
}
